<template>
  <v-container fluid>
    <v-card>
      <v-container class="text-xs-center">
        <v-layout row wrap>
          <v-flex xs12 class="mb-1">
            <v-btn color="primary" block class="mb-4" @click="newSchengen = true">New Schengen Trip</v-btn>
          </v-flex>
        </v-layout>
        <h3>Existing Schengen Trips:</h3>
      </v-container>
      <v-card v-for="trip in schengenTrips" :key="trip.trip_id" class="mb-3">
        <v-card-title>
          <v-layout row wrap>
                  <v-flex xs12 sm6>
                  <div style="display: flex; flex-direction: column; width: 100%;">
                    <div style="display: flex; align-items: flex-start; justify-content: space-between; width: 100%;">
                      <h3 style="margin: 0; display: flex; align-items: center;">
                        <span v-if="trip.country_code" :class="'flag flag-' + trip.country_code" style="margin-right: 10px;"></span>
                        <strong>{{ trip.country }}</strong>
                      </h3>
                      <span style="display: flex; align-items: center;">
                        <v-icon style="color:orange; margin-right:10px" @click="openEditDialog(trip)">edit</v-icon>
                        <v-icon style="color:red" @click="deleteSchengenTrip(trip)">delete</v-icon>
                      </span>
                    </div>
                    <div style="text-align: left; width: 100%; margin-top: 8px;">
                      <h3 style="margin: 0;"><strong>{{ formatDates(trip.start_date, trip.end_date) }}</strong></h3>
                    </div>
                  </div>
            </v-flex>
          </v-layout>
        </v-card-title>
        
      </v-card>
    </v-card>
    <Schengen-Request :showDialog="newSchengen" @closeSchengenRequest="newSchengen = false" @addedSchengen="onTripAdded"></Schengen-Request>
    <Edit-Schengen-Request :showDialog="editSchengen" :trip="selectedTrip" @closeEditSchengenRequest="closeEditDialog" @editSchengenTrip="editSchengenTrip"></Edit-Schengen-Request>
  </v-container>
</template>

<script>
  import format from 'date-fns/format'
  import axios from 'axios'
  export default {
    props: [],
    data () {
      return {
        url: this.$store.getters.url,
        dateFormat: 'Do MMMM YYYY',
        user: this.$store.getters.user,
        company: this.$store.getters.company,
        loading: false,
        newSchengen: false,
        editSchengen: false,
        selectedTrip: null,
        schengenTrips: [],
        addedSchengen: false
      }
    },
    computed: {
    },
    mounted () {
      this.getSchengenTrips()
    },
    methods: {
      onTripAdded () {
        this.newSchengen = false
        this.getSchengenTrips()
      },
      openEditDialog (trip) {
        this.selectedTrip = trip
        this.editSchengen = true
      },
      closeEditDialog () {
        this.editSchengen = false
        this.selectedTrip = null
      },
      editSchengenTrip (updatedTrip) {
        axios.post(this.url + `/tanda-service/alterSchengenTrips.ajax.php`, {
          company: this.company,
          function: 1,
          trip_id: updatedTrip.trip_id,
          emp: this.user.empID,
          country: updatedTrip.country,
          start_date: updatedTrip.startDate,
          end_date: updatedTrip.endDate
        })
          .then(response => {
            this.getSchengenTrips()
          })
          .catch(e => {
            console.log(e)
          })
      },
      deleteSchengenTrip (trip) {
        if (!window.confirm('Are you sure you want to delete this trip?')) {
          return
        }
        axios.post(this.url + `/tanda-service/alterSchengenTrips.ajax.php`, {
          company: this.company,
          function: 0,
          trip_id: trip.trip_id,
          emp: this.user.empID
        })
          .then(response => {
            this.getSchengenTrips()
          })
          .catch(e => {
            console.log(e)
          })
      },
      formatDates (dateOne, dateTwo) {
        let formattedDates = ''
        if (dateOne) {
          formattedDates = format(dateOne, this.dateFormat)
        }
        if (dateTwo && dateTwo !== dateOne) {
          formattedDates += ' - ' + format(dateTwo, this.dateFormat)
        }
        return formattedDates
      },
      getSchengenTrips () {
        axios.post(this.url + `/tanda-service/getSchengenTrips.ajax.php`, {
          company: this.company,
          emp: this.user.empID
        })
          .then(response => {
            this.schengenTrips = Array.isArray(response.data) ? response.data : []
            this.addedSchengen = false
          })
          .catch(e => {
            console.log(e)
          })
      }
    },
    watch: {
      addedSchengen (val) {
        if (!val) {
          this.getSchengenTrips()
        }
      }
    },
    filters: {
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/SchengenTrips.vue